/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 * A Call or Sms attempt state processed so far
 * @export
 * @interface Attempt
 */
export interface Attempt {
  /**
   * result code for the actual attempt when it completed
   * @type {string}
   * @memberof Attempt
   */
  resultCode?: AttemptResultCodeEnum;
  /**
   * last processed state for this call or sms attempt
   * @type {string}
   * @memberof Attempt
   */
  state?: AttemptStateEnum;
}

/**
 * @export
 */
export const AttemptResultCodeEnum = {
  CallpowerdialerNoAvailableAgent: 'call:powerdialer_no_available_agent',
  CalloutboundConnected: 'call:outbound_connected',
  CallpowerdialerVmDrop: 'call:powerdialer_vm_drop',
  CallmachineDetected: 'call:machine_detected',
  CallpowerdialerCall: 'call:powerdialer_call',
  Callactive: 'call:active',
  Calloutbound: 'call:outbound',
  Callcancelled: 'call:cancelled',
  Callinbound: 'call:inbound',
  Callmissed: 'call:missed',
  Callanswered: 'call:answered',
  Callabandoned: 'call:abandoned',
  CalluserInitiated: 'call:user_initiated',
  Calldnc: 'call:dnc',
  CalltimegateFailed: 'call:timegate_failed',
  CallnoConsent: 'call:no_consent',
  Callskipped: 'call:skipped',
  Smsdnt: 'sms:dnt',
  SmstimegateFailed: 'sms:timegate_failed',
  SmsnoConsent: 'sms:no_consent',
  Smsskipped: 'sms:skipped',
  Smsaccepted: 'sms:accepted',
  SmsinvalidDestination: 'sms:invalid_destination',
  SmsinvalidSource: 'sms:invalid_source',
  SmsnoRoute: 'sms:no_route',
  SmsrejectedSpam: 'sms:rejected_spam',
  SmsinternalError: 'sms:internal_error',
  Smsrejected: 'sms:rejected',
  SmsnotSupported: 'sms:not_supported',
  SmstimeOut: 'sms:time_out',
  Smserror: 'sms:error',
  Smsunknown: 'sms:unknown',
  SmsownerNoInternationalMessaging: 'sms:owner_no_international_messaging',
  SmsunregisteredA2pNotAllowed: 'sms:unregistered_a2p_not_allowed',
  SmsownerNotEnoughSmsCredits: 'sms:owner_not_enough_sms_credits',
  SmsownerNotEnoughCredits: 'sms:owner_not_enough_credits',
  SmsmessagingDisabled: 'sms:messaging_disabled',
  SmsownerFreeUser: 'sms:owner_free_user',
  SmscontactMissingNumber: 'sms:contact_missing_number',
  SmscontactIsRoom: 'sms:contact_is_room',
  SmscontactIsSharedLine: 'sms:contact_is_shared_line',
  SmsstaffContact: 'sms:staff_contact',
  SmscompanyAffinity: 'sms:company_affinity',
  SmsnotInFreeCompany: 'sms:not_in_free_company',
  SmsinvalidNumber: 'sms:invalid_number',
} as const;
export type AttemptResultCodeEnum =
  (typeof AttemptResultCodeEnum)[keyof typeof AttemptResultCodeEnum];

/**
 * @export
 */
export const AttemptStateEnum = {
  Pending: 'pending',
  Sending: 'sending',
  Calling: 'calling',
  Vmd: 'vmd',
  Connected: 'connected',
  Hangup: 'hangup',
  Wrapup: 'wrapup',
  Complete: 'complete',
  Skipped: 'skipped',
  Error: 'error',
} as const;
export type AttemptStateEnum =
  (typeof AttemptStateEnum)[keyof typeof AttemptStateEnum];

/**
 * Check if a given object implements the Attempt interface.
 */
export function instanceOfAttempt(value: object): value is Attempt {
  return true;
}

export function AttemptFromJSON(json: any): Attempt {
  return AttemptFromJSONTyped(json, false);
}

export function AttemptFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Attempt {
  if (json == null) {
    return json;
  }
  return {
    resultCode: json['result_code'] == null ? undefined : json['result_code'],
    state: json['state'] == null ? undefined : json['state'],
  };
}

export function AttemptToJSON(value?: Attempt | null): any {
  if (value == null) {
    return value;
  }
  return {
    result_code: value['resultCode'],
    state: value['state'],
  };
}
